import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useCallback } from 'react';
import { setCreateGameCurrencyIndex } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ALL_CURRENCIES, CURRENCY_NAMES } from '../../../types/sharedTypes';
export const CurrencyControl = () => {
    const dispatch = useAppDispatch();
    const currencyIndex = useAppSelector((state) => state.createGame.currencyIndex);
    const onChangeCurrency = useCallback((event) => {
        dispatch(setCreateGameCurrencyIndex(Number(event.target.value)));
    }, [dispatch]);
    return (_jsxs(FormControl, { variant: 'outlined', children: [_jsx(InputLabel, { children: "Currency" }), _jsx(Select, { "data-testid": 'create-game-currency-select', value: `${currencyIndex}`, label: 'Currency', onChange: onChangeCurrency, children: ALL_CURRENCIES.map((currency, i) => (_jsx(MenuItem, { value: i, children: CURRENCY_NAMES[currency] }, i))) })] }));
};
